import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate1_5x.svg'

export const IconPlaybackRate1_5x = IconSVG as IconComponent
